import React from "react";

import OnSvg from "../../assets/images/icons/on.svg";

export const CheckedIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={OnSvg}
        alt={alt || "Checked"}
    />
);
